import { inject, Injectable } from '@angular/core';
import { CommandHandlerFor, Http } from '@skylab-angular-shared/core';
import { Command, CommandHandler, HttpService, TaggedUrl, Tags } from '@skylab-shared/core';
import { MS_PER_MINUTE } from '@skylab-shared/utils';

export interface EInvoiceReceivedGenerateCollectiveIdentifierParams {
    ksefNumbers: string[];
}

export type EInvoiceReceivedGenerateCollectiveIdentifierResponse = {
    collectiveIdentifier: string;
};

export class EInvoiceReceivedGenerateCollectiveIdentifierCommand extends Command<EInvoiceReceivedGenerateCollectiveIdentifierParams, EInvoiceReceivedGenerateCollectiveIdentifierResponse> { }

@CommandHandlerFor(EInvoiceReceivedGenerateCollectiveIdentifierCommand)
@Injectable({ providedIn: 'root'})
export class EInvoiceReceivedGenerateCollectiveIdentifierHandler implements CommandHandler<EInvoiceReceivedGenerateCollectiveIdentifierCommand, EInvoiceReceivedGenerateCollectiveIdentifierParams, EInvoiceReceivedGenerateCollectiveIdentifierResponse> {
    #url = TaggedUrl.join('eInvoices/collective-identifier', [Tags.Api]);
    #http = inject(Http) as HttpService;

    public async handleAsync({ params }: EInvoiceReceivedGenerateCollectiveIdentifierCommand): Promise<EInvoiceReceivedGenerateCollectiveIdentifierResponse> {
        const { data } = await this.#http.post<EInvoiceReceivedGenerateCollectiveIdentifierResponse>(this.#url, { ksefNumbers: params?.ksefNumbers }, { timeout: 3 * MS_PER_MINUTE });
        return data;
    }
}
